import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({
  children,
  className = "",
  delay = 0,
  testId,
  as = "div",
}) => {
  const Component = motion[as] || motion.div;

  return (
    <Component
      className={className}
      data-testid={testId}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.16 }}
      transition={{ duration: 0.9, delay, ease }}
    >
      {children}
    </Component>
  );
};

export const HeroLine = ({ children, className = "", delay = 0 }) => (
  <span className={`hero-line-mask ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.15, delay, ease }}
    >
      {children}
    </motion.span>
  </span>
);

export const PageTransition = ({ children }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.55, ease }}
  >
    {children}
  </motion.div>
);